var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ResendInvitationConfirmation", {
    attrs: { givenName: _vm.givenName, familyName: _vm.familyName },
    on: { confirmed: _vm.resendInvitation },
    scopedSlots: _vm._u(
      [
        {
          key: "default",
          fn: function ({ confirm }) {
            return [
              _vm._t(
                "default",
                function () {
                  return [
                    !_vm.showSmallButton
                      ? _c("UiButton", {
                          attrs: {
                            size: "lg",
                            variant: "black",
                            buttonText: _vm.buttonText,
                            disabled: _vm.processing,
                            buttonClasses: "px-2 pr-4 pl-4 customHeight",
                            processing: _vm.processing,
                          },
                          on: { click: confirm },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "icon",
                                fn: function () {
                                  return [
                                    _c("ViewIcon", { staticClass: "w-4 h-4" }),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "hover-icon",
                                fn: function () {
                                  return [
                                    _c("ViewIconBlack", {
                                      staticClass: "w-4 h-4",
                                    }),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "disabled",
                                fn: function () {
                                  return [
                                    _c("ViewIconBlack", {
                                      staticClass: "w-4 h-4",
                                    }),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _c(
                          "button",
                          {
                            staticClass:
                              "flex items-center justify-center gap-1 w-full focus:outline-none",
                            attrs: { type: "button" },
                            on: { click: confirm },
                          },
                          [
                            _c("img", {
                              staticClass: "h-4 w-4",
                              attrs: {
                                src: require("@/assets/up-right-icon.svg"),
                                alt: "resend",
                              },
                            }),
                            _c("span", { staticClass: "invite-text" }, [
                              _vm._v("Resend invite"),
                            ]),
                          ]
                        ),
                  ]
                },
                {
                  resendInvitation: confirm,
                  processing: _vm.processing,
                  invitationResent: _vm.invitationResent,
                }
              ),
            ]
          },
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }